import React, { useState, useEffect } from 'react';
import './ProjectUpdate.css';
import { API_URL } from "./API";

const ProjectUpdate = ({ project, onBack, onUpdate }) => {
  const [formData, setFormData] = useState({
    projectName: '',
    startDate: '',
    vendor: '',
    numberOfBlocks: '',
    status: 'Pipelined', 
    client: '',
    location: '',
    quotation: '',
    city: '',
    pincode: '',
    equipment: '',
    email: '',
    password: ''
  });

  const [isLoading, setIsLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [clients, setClients] = useState([]);
  const [isLoadingVendors, setIsLoadingVendors] = useState(false);
  const [isLoadingClients, setIsLoadingClients] = useState(false);

  const statusOptions = ['Pipelined', 'Ongoing', 'Completed', 'InActive', 'Active'];
  const equipmentOptions = ['Current Transformer(CT)', 'Circuit Breaker(CB)', 'RELAYS', 'RELAYS CT', 'VT', 'CABLES', 'BUSBAR', 'TRANSFORMERS'];

  const fetchVendors = async () => {
    setIsLoadingVendors(true);
    try {
      const response = await fetch(`${API_URL}/vendors/get_vendor`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      if (result.status === 'success' && result.data) {
        setVendors(result.data);
      } else {
      
        setVendors([]);
      }
    } catch (error) {
    
      setVendors([]);
    } finally {
      setIsLoadingVendors(false);
    }
  };

  const fetchClients = async () => {
    setIsLoadingClients(true);
    try {
      const response = await fetch(`${API_URL}/clients/get_client`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        mode: 'cors'
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      if (result.status === 'success' && result.data) {
        setClients(result.data);
      } else {
      
        setClients([]);
      }
    } catch (error) {
     
      setClients([]);
    } finally {
      setIsLoadingClients(false);
    }
  };

  useEffect(() => {
    if (project) {
      

      setFormData({
        projectName: project.project_name || project.name || '',
        startDate: project.starting_date ? project.starting_date.split("T")[0] : project.startDate || '',
        vendor: project.vendor_id || project.vendor || '',
        numberOfBlocks: project.no_of_blocks || project.numberOfBlocks || '',
        status: project.status || 'Pipelined',
        client: project.client_id || project.client || '',
        location: project.location || '',
        quotation: project.amount_in_rupees || project.quotation || '',
        city: project.city ? project.city : '',
        pincode: project.pincode ? project.pincode : '',
        equipment: project.equipment || '',
        email: project.email || '',
        password: project.password || ''
      });

    
    }

    fetchVendors();
    fetchClients();
  }, [project]);

  useEffect(() => {
    if (formData.client && clients.length > 0) {
      const selectedClient = clients.find(
        c => c.client_id === parseInt(formData.client) || c.id === parseInt(formData.client)
      );
      
      if (selectedClient && selectedClient.email) {
      
        setFormData(prev => ({
          ...prev,
          email: selectedClient.email
        }));
      }
    }
  }, [formData.client, clients]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleForgotPassword = () => {
    if (!formData.email) {
      alert('Please enter your email address first');
      return;
    }
    alert(`Password reset link will be sent to: ${formData.email}`);
  };

const handleSubmit = async () => {
   
    if (formData.numberOfBlocks && (isNaN(formData.numberOfBlocks) || parseInt(formData.numberOfBlocks) < 0)) {
      alert('Number of blocks must be a non-negative number');
      return;
    }

    
    if (formData.quotation && (isNaN(formData.quotation) || parseFloat(formData.quotation) < 0)) {
      alert('Quotation must be a non-negative number');
      return;
    }

    
    if (formData.vendor && (isNaN(formData.vendor) || parseInt(formData.vendor) <= 0)) {
      alert('Vendor ID must be a positive number');
      return;
    }

    
    if (formData.client && (isNaN(formData.client) || parseInt(formData.client) <= 0)) {
      alert('Client ID must be a positive number');
      return;
    }

    
    if (formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      alert('Please enter a valid email address');
      return;
    }

   
    if (formData.password && formData.password.length < 6) {
      alert('Password must be at least 6 characters long');
      return;
    }

    
    if ((formData.email && !formData.password) || (!formData.email && formData.password)) {
      alert('Both email and password are required for client credentials');
      return;
    }

    
    if ((formData.email || formData.password) && !formData.client) {
      alert('Please select a client before providing email and password credentials');
      return;
    }

    setIsLoading(true);

    try {
      const projectData = {
      project_id: project.id || project.project_id,
      project_name: formData.projectName.trim(),
      status: formData.status,
      location: formData.location.trim(),
      vendor_id: formData.vendor ? parseInt(formData.vendor) : null,
      client_id: formData.client ? parseInt(formData.client) : null,
      amount_in_rupees: formData.quotation ? parseFloat(formData.quotation) : null,
      no_of_blocks: formData.numberOfBlocks || null,
      equipment: formData.equipment,
      city: formData.city,
      pincode: formData.pincode,
      email: formData.email,
      password: formData.password
    };

      
      if (formData.startDate) {
        projectData.starting_date = formData.startDate;
      }
      
      if (formData.vendor) {
        projectData.vendor_id = parseInt(formData.vendor);
      }
      
      if (formData.client) {
        projectData.client_id = parseInt(formData.client);
      }
      
      if (formData.quotation) {
        projectData.quotation_in_words = `${parseFloat(formData.quotation)} Rupees`;
        projectData.amount_in_rupees = parseFloat(formData.quotation);
      }
      
      if (formData.numberOfBlocks) {
        projectData.no_of_blocks = formData.numberOfBlocks.toString();
      }
      
      if (formData.equipment) {
        projectData.equipment = formData.equipment;
      }
      
      if (formData.city && formData.city.trim()) {
        projectData.city = formData.city.trim();
      }
      
      if (formData.pincode && formData.pincode.trim()) {
        projectData.pincode = formData.pincode.trim();
      }
      
     
      if (formData.email && formData.email.trim()) {
        projectData.email = formData.email.trim();
      }
      
      if (formData.password && formData.password.trim()) {
        projectData.password = formData.password.trim();
      }

      

      const response = await fetch(`${API_URL}/projects/create_update_projects`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS',
          'Access-Control-Allow-Headers': 'Content-Type, Accept'
        },
        body: JSON.stringify(projectData),
        mode: 'cors' 
      });

      if (!response.ok) {
        let errorMessage = `HTTP ${response.status}: ${response.statusText}`;
        
        try {
          const errorResult = await response.json();
          if (errorResult.message) {
            errorMessage = errorResult.message;
          }
        } catch (jsonError) {
   
        }
        
        throw new Error(errorMessage);
      }

      const result = await response.json();
    if (!response.ok) throw new Error(result.message);

    alert("Project updated & credentials sent successfully!");
    onBack();

      if (result.status === 'success' && result.data) {
        const apiData = result.data;
        
        const updatedProject = {
          id: apiData.project_id,
          project_id: apiData.project_id,
          project_name: apiData.project_name,
          name: apiData.project_name, 
          status: apiData.status,
          location: apiData.location,
          starting_date: apiData.starting_date,
          startDate: apiData.starting_date,
          vendor_id: apiData.vendor_id,
          vendor: apiData.vendor_id,
          client_id: apiData.client_id,
          client: apiData.client_id, 
          amount_in_rupees: apiData.amount_in_rupees,
          quotation: apiData.amount_in_rupees,
          no_of_blocks: apiData.no_of_blocks,
          numberOfBlocks: apiData.no_of_blocks, 
          blocks: apiData.no_of_blocks ? `${apiData.no_of_blocks} Blocks` : 'N/A Blocks',
          equipment: apiData.equipment || '',
          city: apiData.city || '',
          pincode: apiData.pincode || '',
          email: formData.email || '',
          password: '', 
          originalData: {
            ...project.originalData,
            ...apiData,
            project_name: apiData.project_name,
            no_of_blocks: apiData.no_of_blocks,
            status: apiData.status,
            location: apiData.location,
            starting_date: apiData.starting_date,
            vendor_id: apiData.vendor_id,
            client_id: apiData.client_id,
            amount_in_rupees: apiData.amount_in_rupees
          }
        };

       

        if (onUpdate) {
          onUpdate(updatedProject);
        }
        
        
        if (result.email_sent) {
          alert('✅ Project updated successfully!\n\n📧 Client credentials have been sent to: ' + formData.email);
        } else if (formData.email && formData.password) {
          alert('⚠️ Project updated successfully!\n\nNote: Client credentials were saved but email sending failed.\nPlease inform the client manually:\n\nEmail: ' + formData.email + '\nPassword: ' + formData.password);
        } else {
          alert('✅ Project updated successfully!');
        }
        
        
        setFormData(prev => ({
          ...prev,
          password: ''
        }));
        
        if (onBack) {
          onBack();
        }
      } else {
        throw new Error('Unexpected API response format');
      }

    } catch (error) {
  
      
      if (error.name === 'TypeError') {
        if (error.message.includes('fetch')) {
          alert('❌ Network Error: Cannot connect to server.\n\nPlease check:\n1. Backend server is running on ' + API_URL + '\n2. CORS is properly configured\n3. No firewall blocking the connection');
        } else {
          alert(`❌ Request Error: ${error.message}`);
        }
      } else if (error.message.includes('CORS')) {
        alert('❌ CORS Error: The backend server is not allowing requests from this origin.\n\nPlease ensure CORS is properly configured in your Flask application.');
      } else if (error.message.includes('Email') && error.message.includes('already registered')) {
        alert('❌ ' + error.message + '\n\nPlease use a different email address or update the existing client record.');
      } else if (error.message.includes('400')) {
        alert(`❌ Bad Request: ${error.message}\n\nThis usually means the request format is incorrect or required fields are missing.`);
      } else if (error.message.includes('404')) {
        alert('❌ Not Found: The project or client was not found in the database.\n\nPlease refresh the page and try again.');
      } else if (error.message.includes('500')) {
        alert('❌ Server Error: Internal server error occurred.\n\nPlease check the backend logs for more details.');
      } else {
        alert(`❌ Failed to update project: ${error.message}`);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    }
  };

  return (
    <div className="PU-00">
      <div className="PU-01">
        <h2 className="PU-02">
          Update Project {project?.project || ''}
        </h2>
        
        <div className="PU-03">
          <div className="PU-04">
            <div>
              <label className="PU-05">
                Project Name
              </label>
              <input 
                type="text"
                name="projectName"
                placeholder="Enter Project Name"
                value={formData.projectName}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
              />
            </div>
            <div>
              <label className="PU-05">
                Start Date
              </label>
              <input 
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="PU-04">
            <div>
              <label className="PU-05">
                Vendor Name
              </label>
              <select 
                name="vendor"
                value={formData.vendor}
                onChange={handleInputChange}
                className="PU-08"
                disabled={isLoading || isLoadingVendors}
              >
                <option value="">
                  {isLoadingVendors ? 'Loading vendors...' : 'Select Vendor'}
                </option>
                {vendors.map((vendor) => (
                  <option key={vendor.vendor_id} value={vendor.vendor_id}>
                    {vendor.vendor_name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="PU-05">
                Number Of Blocks
              </label>
              <input 
                type="number"
                name="numberOfBlocks"
                placeholder="Enter Number of Blocks"
                value={formData.numberOfBlocks}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
                min="0"
              />
            </div>
          </div>

          <div className="PU-04">
            <div>
              <label className="PU-05">
                Status
              </label>
              <select 
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                className="PU-08"
                disabled={isLoading}
              >
                <option value="">Select Status</option>
                {statusOptions.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="PU-05">
                Client Name
              </label>
              <select 
                name="client"
                value={formData.client}
                onChange={handleInputChange}
                className="PU-08"
                disabled={isLoading || isLoadingClients}
              >
                <option value="">
                  {isLoadingClients ? 'Loading clients...' : 'Select Client'}
                </option>
                {clients.map((client) => (
                  <option key={client.client_id} value={client.client_id}>
                    {client.client_name}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="PU-04">
            <div>
              <label className="PU-05">
                Location
              </label>
              <input 
                type="text"
                name="location"
                placeholder="Enter Location"
                value={formData.location}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
              />
            </div>
            <div>
              <label className="PU-05">
                Quotation (₹)
              </label>
              <input 
                type="number"
                name="quotation"
                placeholder="Enter Quotation Amount"
                value={formData.quotation}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
                min="0"
                step="0.01"
              />
            </div>
          </div>

          <div className="PU-04">
            <div>
              <label className="PU-05">
                Equipment
              </label>
              <select 
                name="equipment"
                value={formData.equipment}
                onChange={handleInputChange}
                className="PU-08"
                disabled={isLoading}
              >
                <option value="">Select Equipment</option>
                {equipmentOptions.map((option, index) => (
                  <option key={index} value={option}>{option}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="PU-05">
                City
              </label>
              <input 
                type="text"
                name="city"
                placeholder="Enter City"
                value={formData.city}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="PU-04">
            <div>
              <label className="PU-05">
                Pincode
              </label>
              <input 
                type="text"
                name="pincode"
                placeholder="Enter Pincode"
                value={formData.pincode}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
                pattern="[0-9]{6}"
                maxLength="6"
              />
            </div>
            <div>
              <label className="PU-05">
                Email
              </label>
              <input 
                type="email"
                name="email"
                placeholder="Enter Email Address"
                value={formData.email}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="PU-04">
            <div>
              <label className="PU-05">
                Password
              </label>
              <input 
                type="password"
                name="password"
                placeholder="Enter Password"
                value={formData.password}
                onChange={handleInputChange}
                className="PU-07"
                disabled={isLoading}
              />
            </div>
            <div></div>
          </div>
        </div>

        <div className="PU-09">
          <button 
            type="button" 
            onClick={handleBack}
            className="PU-10"
            disabled={isLoading}
          >
            Back
          </button>
          <button 
            type="button" 
            onClick={handleSubmit}
            className="PU-11"
            disabled={isLoading}
          >
            {isLoading ? 'Updating...' : 'Update Project'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProjectUpdate;